module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/shield-background-2890fa974a52cf945ccdeb1ccf4965c7.png";